/* document.addEventListener("DOMContentLoaded", function () {
  const oneTimeInput = document.getElementById("purchaseTypeOneTime");
  const subscriptionInput = document.getElementById("purchaseTypeSubscription");

  function refreshVariantState() {
    const oneTime = window.oneTimePurchase;
    const subscription = window.subscriptionPlans;

    const variantInputs = document.querySelectorAll("variant-selects input[data-var]");
    const isSubscription = subscriptionInput?.checked;

    const dataObject = isSubscription ? subscription : oneTime;

    variantInputs.forEach((input) => {
      const variantId = input.getAttribute("data-var");
      const data = isSubscription ? dataObject[variantId]?.[1] : dataObject[variantId];
      if (!data) return;

      input.value = data.title || "";

      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      const discountLabel = label.querySelector(".discount-label");
      if (discountLabel) {
        const discount = Number(data.discount_percent) || 0;
        discountLabel.textContent = discount > 0 ? `${discount}% OFF` : "";
      }

      const taglineText = label.querySelector(".tagline-text");
      if (taglineText) {
        taglineText.textContent = data.tagline_text || "";
      }
    });

    const selectedInput = Array.from(variantInputs).find(input => input.checked);
    if (!selectedInput) return;

    const selectedVariantId = selectedInput.getAttribute("data-var");
    const selectedData = isSubscription ? dataObject[selectedVariantId]?.[1] : dataObject[selectedVariantId];
    if (!selectedData) return;

    const price = Number(isSubscription ? selectedData.plan_price : selectedData.price) || 0;
    const comparePrice = Number(isSubscription ? selectedData.original_price : selectedData.compare_at_price) || 0;

    const priceContainer = document.querySelector(".price");
    if (priceContainer) {
      const compareAt = priceContainer.querySelector("s.price-item--regular");
      const regularPrice = priceContainer.querySelector(".price-item--regular:not(s.price-item--regular)");
      const salePrice = priceContainer.querySelector(".price-item--sale");

      if (price > 0 && regularPrice && salePrice) {
        if (comparePrice > price && compareAt) {
          compareAt.textContent = `₪${comparePrice}`;
          compareAt.style.display = "inline";
        } else if (compareAt) {
          compareAt.style.display = "none";
          compareAt.textContent = "";
        }

        regularPrice.textContent = `₪${comparePrice}`;
        salePrice.textContent = `₪${price}`;
      }
    }

    if (!isSubscription) {
      const variantTitle = selectedInput.value;
      const oneTimeData = Object.values(oneTime).find(v => v.title === variantTitle);
      if (oneTimeData && oneTimeData.compare_at_price) {
        const container = document.querySelector(".rtx-purchase-label__inner .one-time-purchase-label");
        if (container) {
          container.querySelector(".compare-price-span")?.remove();
          const span = document.createElement("span");
          span.classList.add("compare-price-span");
          span.textContent = `$${oneTimeData.compare_at_price}`;
          container.appendChild(span);
        }
      }
    }
  }

  // === Events ===

  // Change event for variant selection
  document.addEventListener("change", function (event) {
    const input = event.target.closest('variant-selects input[data-var]');
    if (!input) return;
    refreshVariantState();
  });

  // Purchase type change
  oneTimeInput?.addEventListener("change", refreshVariantState);
  subscriptionInput?.addEventListener("change", refreshVariantState);

  // Initial load
  refreshVariantState();

  // Expose globally if needed to call after HTML update
  window.refreshVariantState = refreshVariantState;
}); */

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get("page"));

  if (page && page > 1) {
    const target = document.querySelector(".main-blog");
    if (target) {
      const topOffset = 56; // space from top in pixels
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - topOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  }
});




document.addEventListener('DOMContentLoaded', function () {
  const level2Links = document.querySelectorAll('.mega-menu__link--level-2[data-child-id]');
  const contentLists = document.querySelectorAll('.grandchild-group');
  let lastActiveId = null;

  function showList(targetId) {
    let matched = false;

    // Show/hide grandchild lists
    contentLists.forEach(list => {
      const id = list.getAttribute('data-child-id');
      const isMatch = id === targetId;
      list.style.display = isMatch ? 'flex' : 'none';
      if (isMatch) matched = true;
    });

    // Update active class on level-2 links
    level2Links.forEach(link => {
      const id = link.getAttribute('data-child-id');
      link.classList.toggle('mega-menu__link--active', id === targetId);
    });

    if (matched) {
      lastActiveId = targetId;
    }
  }

  // ✅ Auto-select the first level-2 link on load
  if (level2Links.length > 0) {
    const firstLink = level2Links[0];
    const firstId = firstLink.getAttribute('data-child-id');
    showList(firstId);
  }

  // ✅ Switch group on hover over level-2 links
  level2Links.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const targetId = link.getAttribute('data-child-id');
      const matchingGroup = document.querySelector(`.grandchild-group[data-child-id="${targetId}"]`);
      if (matchingGroup) {
        showList(targetId);
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const hoverDetails = document.querySelectorAll('[data-hover-details]');
  const closeDelay = 200; // milliseconds

  hoverDetails.forEach((detail) => {
    const summary = detail.querySelector('summary');
    let closeTimeout;

    if (!summary) return;

    // Open on mouse enter
    detail.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      detail.setAttribute('open', '');
    });

    // Close on mouse leave with delay
    detail.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        detail.removeAttribute('open');
      }, closeDelay);
    });

    // Prevent toggle on click
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const detailsMenus = document.querySelectorAll('details[data-hover-details]');
  const bodyClass = 'mega-menu--open';

  detailsMenus.forEach(detail => {
    detail.addEventListener('toggle', () => {
      // Add class if any menu is open
      const anyOpen = [...detailsMenus].some(d => d.open);
      document.body.classList.toggle(bodyClass, anyOpen);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  setInterval(function () {
    const arrow = document.querySelector('.rebuy-carousel__arrow--next');
    if (arrow) {
      arrow.click();
    } else {
      console.warn('Arrow element not found');
    }
  }, 5000);
});

document.addEventListener("DOMContentLoaded", function () {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();

  const isMac = platform.includes('mac');
  const isIphone = userAgent.includes('iphone');
  const isChrome = userAgent.includes('chrome') && !userAgent.includes('edge') && !userAgent.includes('opr');
  const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
  const isFirefox = userAgent.includes('firefox');

  if ((isMac || isIphone) && (isChrome || isSafari) && !isFirefox) {
    document.body.classList.add('mac');
  }
});

  function custom_addtocart_fun(product,open_drawer){
    console.log("product",product);
    fetch(`${routes.cart_add_url}`,{ 
      method: 'POST',
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(product)
    })
    .then(response => response.json()).then(response => {     
      // console.log("res..",response);   
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally((e) => {
      if(open_drawer){
        // reset the  product data normal
        // document.querySelectorAll(".bundle_qty .quantity__input").forEach(input => {
        //   input.value = 0;
        // });
        const this_cartDrawer = document.querySelector('cart-drawer');
        this_cartDrawer.refresh(true);
      }
      
    });
  }

// oneTime subscription widget change event logic(new)
let variantDiscounts = {};

function updateAllDiscountLabels(type = "otp") {
  document.querySelectorAll(".discount-label").forEach((label) => {
    const variantId = label.dataset.variantId;
    const data = variantDiscounts[variantId];

    if (!data) return;

    // const discount = type === "sub" ? data.sub : data.otp;

    const discount = Number(
      type === "sub" ? data.sub : data.otp
    ) || 0;

    // if (discount <= 0) {
    //   label.style.display = "none";
    //   return;
    // }

    // if (label.dataset.template) {
    //   label.innerHTML = label.dataset.template.replace(
    //     "[percentage]",
    //     discount
    //   );
    // }

    if (discount > 0) {
      label.style.display = "";

      if (label.dataset.template) {
        label.innerHTML = label.dataset.template.replace(
          "[percentage]",
          discount
        );
      }
    } else {
      label.style.display = "none";
    }
  });
}

// function updateATCPrice() {
//   const checkedOption = document.querySelector(
//     'input[name="purchase_options"]:checked'
//   );

//   let selectedPriceWrap;

//   if (checkedOption?.value === "subscription") {
//     selectedPriceWrap = document.querySelector(
//       '#purchase_options_sub + label .otp-price-wrap'
//     );
//   } else {
//     selectedPriceWrap = document.querySelector(
//       '#purchase_options_otp + label .otp-price-wrap'
//     );
//   }

//   const atcPriceWrapper = document.querySelector('[id^="ATC-Price-"]');

//   if (!selectedPriceWrap || !atcPriceWrapper) return;

//   const priceSign =
//     atcPriceWrapper.querySelector('.price-sign')?.outerHTML || '';

//   atcPriceWrapper.innerHTML =
//     priceSign + selectedPriceWrap.innerHTML;

//   const atcCprice = atcPriceWrapper.querySelector('[data-atc_cprice]');
//   const atcPrice = atcPriceWrapper.querySelector('[data-atc_price]');

//   // Convert current prices to money_without_trailing_zeros format
//     [atcCprice, atcPrice].forEach((el) => {
//       if (!el) return;

//       el.textContent = el.textContent.replace(
//         /(\d+)\.(\d+)(?=\D*$)/,
//         (match, integer, decimal) => {
//           return `${integer}.${decimal.replace(/0+$/, '')}`;
//         }
//       ).replace(/\.(?=\D*$)/, '');
//     });
// }

function updateATCPrice() {
  const checkedOption = document.querySelector(
    'input[name="purchase_options"]:checked'
  );

  let selectedPriceWrap;

  if (checkedOption?.value === "subscription") {
    selectedPriceWrap = document.querySelector(
      '#purchase_options_sub + label .otp-price-wrap'
    );
  } else {
    selectedPriceWrap = document.querySelector(
      '#purchase_options_otp + label .otp-price-wrap'
    );
  }

  if (!selectedPriceWrap) return;

  const atcPriceWrappers = document.querySelectorAll(
    '[data-atc-price-display]'
  );

  atcPriceWrappers.forEach((wrapper) => {
    const priceSign = wrapper.querySelector('.price-sign');

    // Preserve the existing price sign
    const signHTML = priceSign ? priceSign.outerHTML : '';

    // Update only after a valid source price is found
    wrapper.innerHTML = signHTML + selectedPriceWrap.innerHTML;

    const atcCprice = wrapper.querySelector('[data-atc_cprice]');
    const atcPrice = wrapper.querySelector('[data-atc_price]');

    [atcCprice, atcPrice].forEach((el) => {
      if (!el) return;

      el.textContent = el.textContent.replace(
        /(\d+)\.(\d+)(?=\D*$)/,
        (match, integer, decimal) =>
          `${integer}.${decimal.replace(/0+$/, '')}`
      ).replace(/\.(?=\D*$)/, '');
    });
  });
}

function toggleSubscriptionSelector() {
  const checkedOption = document.querySelector(
    'input[name="purchase_options"]:checked'
  );

  const subsSelector = document.querySelector(".subs-selector");

  if (subsSelector) {
    if (checkedOption?.value === "subscription") {
      subsSelector.classList.remove("hidden");
      updateAllDiscountLabels("sub");
    } else {
      subsSelector.classList.add("hidden");
      updateAllDiscountLabels("otp");
    }
  }

  updateATCPrice();
  
}

document.addEventListener("DOMContentLoaded", () => {
  const variantDiscountsEl = document.getElementById("variant-discounts");

  if (variantDiscountsEl) {
    variantDiscounts = JSON.parse(variantDiscountsEl.textContent);
  }

  document.addEventListener("change", (e) => {
    if (e.target.name === "purchase_options") {
      toggleSubscriptionSelector();
    }
  });

  toggleSubscriptionSelector();
});

// dilivery frequency 1 2 3 month 


document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('lsg-bundle-interval-frequency-select')) {
    return;
  }

  const discountValue = Number(
    e.target.options[e.target.selectedIndex].dataset.discountValue
  );

  // Discount Label Update
  const input = document.querySelector(
    'variant-selects input[type="radio"]:checked'
  );

  if (!input) return;

  const label = input.labels?.[0];
  if (!label) return;

  const labelInn = label.querySelector('span.discount-label');

  if (labelInn) {
    labelInn.innerHTML = labelInn.dataset.template.replace(
      '[percentage]',
      discountValue
    );
  }

  // Subscription Price Update
  const priceEl = document.querySelector(
    '#purchase_options_sub + label .single-interval-otp-dis-price'
  );

  if (!priceEl) return;

  const basePrice = Number(priceEl.dataset.basePrice);

  const discountedPrice =
    basePrice - (basePrice * discountValue / 100);

    console.log("discountedPrice",discountedPrice)

  // Money Format => ₪279.00
  priceEl.innerHTML =
    '₪' + (discountedPrice / 100).toFixed(2);

  updateATCPrice();
});

// propetices

document.querySelector('.defult-btn.product-form__submit')?.addEventListener('click', async function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const variantId = document.querySelector('input[name="id"]')?.value;
  if (!variantId) return;

  

  const checkedOption = document.querySelector('input[name="purchase_options"]:checked');
  const checkedOptionVariant = document.querySelector('input[data-custom_name]:checked');

  const newTimestamp = Math.floor(Date.now() / 1000);
  window.bundleTimestamp = newTimestamp;

  let properties = {
    _blockType: checkedOptionVariant.getAttribute('data-custom_name'),
    timestamp: newTimestamp,
    _selling_plan: checkedOption?.value === 'subscription' ? 'subscription' : 'one_time'
  };

  

  if (checkedOption?.value === 'subscription') {
    const select = document.querySelector('.lsg-bundle-interval-frequency-select');
    const plan = JSON.parse(select.options[select.selectedIndex].dataset.sellingPlan);

    properties = {
      ...properties,
      Frequency: plan.name,
      '_[DD]_interval_type': plan.delivery.interval,
      '_[DD]_interval_number': Number(plan.delivery.interval_count),
      '_[DD]_billing_interval_type': plan.delivery.interval,
      '_[DD]_billing_interval_number': Number(plan.delivery.interval_count),
      '_[DD]_pricing_policy_fixed_adjustment_type': plan.discount.type,
      '_[DD]_pricing_policy_fixed_adjustment_value': Number(plan.discount.value),
      '_[DD]_pricing_policy_recurring_adjustment_type': plan.discount.type,
      '_[DD]_pricing_policy_recurring_adjustment_value': Number(plan.discount.value)
    };
  }

  console.log('properties', properties);

  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
        properties
      }
    ]
  };

  this.setAttribute('aria-disabled', true);
  this.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(res => {
      console.log('Added', res);

      this.querySelector('.loading__spinner').classList.add('hidden');
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
    })
    .catch(err => {
      console.error(err);
      this.querySelector('.loading__spinner').classList.add('hidden');
      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
    });
});




// document.addEventListener("change", function (event) {
//   const input = event.target.closest('variant-selects input[data-var]');
//   if (!input) return;

//   const variantId = input.getAttribute("data-var");

//   // Update title only on Starter Bundle product
//   if (window.location.pathname.includes("/products/the-starter-bundle")) {
//     const productTitle = document.querySelector(
//       "h1.product__title, .product__title h1, .product__title"
//     );

//     if (!productTitle) return;

//     if (variantId === "67822210580671") { 
//       productTitle.textContent = 'The “Starter” Bundle';
//     } else if (variantId === "67822210613439") {
//       productTitle.textContent = 'Tempeh “Lover” Pack';
//     }
//   }
// });


document.addEventListener("change", function (event) {
  const input = event.target.closest('variant-selects input[data-var]');
  if (!input) return;

  const variantId = input.getAttribute("data-var");

  // Only update title on Starter Bundle product
  if (window.location.pathname.includes("/products/the-starter-bundle")) {
    const productTitle = document.querySelector(
      "h1.product__title, .product__title h1, .product__title"
    );

    if (!productTitle) return;

    // Detect Hebrew language
    const isHebrew =
      document.documentElement.lang.toLowerCase().startsWith("he") ||
      window.location.pathname.startsWith("/he/");

    if (variantId === "67822210580671") {
      productTitle.textContent = isHebrew
        ? 'מארז היכרות'
        : 'The “Starter” Bundle';

    } else if (variantId === "67822210613439") {
      productTitle.textContent = isHebrew
        ? 'מארז היכרות XL'
        : 'The “Starter” Bundle XL';
    }
  }
});


